import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { Agency } from "@shared/lib/types/agency";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { BackednResponse } from "@shared/lib/types";

export function useUpdateAgency() {
  const {
    mutate: updateAgency,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    {
      agencyId: string;
      data: Partial<Agency>;
    },
    BackednResponse<Agency> | void
  >({
    mutationFn: ({ agencyId, data }) => {
      return AgencyService.updateAgency(data, agencyId).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { agencyId }) => {
      c.invalidateQueries({ queryKey: AGENCY_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
    },
  });

  return {
    updateAgency,
    isUpdating,
    isUpdated,
  };
}
